__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-05-08-1778242515-stable-dev/";